import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { IBranch } from 'app/shared/Domains/branch';
import { ICompany } from 'app/shared/Domains/company';
import { IMember } from 'app/shared/Domains/member';
import { IRole } from 'app/shared/Domains/role';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { IUser } from 'app/shared/Domains/IUser';
import { ActivatedRoute, Router } from "@angular/router";
import { LanguageService } from 'app/LanguageService/Language.Service';
import { Output, EventEmitter } from '@angular/core';
@Component({
    selector: "add-vitals",
    templateUrl: "./add-vitals.component.html",
    styleUrls: ["./add-vitals.component.css"],
})
export class AddVitalsComponent implements OnInit {
    @Output() closeDialog = new EventEmitter<void>();
    showBodySpecPopup = false;

    bodySpec = {
        totalBodyWater: 0,
        protein: 0,
        mineral: 0,
        bodyFatMass: 0,
        weight: 0,
        sMM: 0,
        bMI: 0,
        pBF: 0,
        waistHipRatio: 0,
        visceralFatLevel: 0,
        height: 0,
        _id: 0,
    };
    member: any;
    company: ICompany;
    role: IRole;
    branch: IBranch;
    memberID: any;
    user: IUser;
    currentUserData: any;
    addVitalsDialog: boolean = false;

    constructor(
        private LanguageService: LanguageService,
        private messageService: MessageService,
        private route: ActivatedRoute,
        private appServiceManager: AppServiceManager,
    ) {
        route.params.subscribe((params) => {
            if (this.memberID === undefined) {
                this.memberID = params["id"];
            }
        });

    }
    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("AddMembersComponent", label);
    }
    ngOnInit(): void {
        const currentUser = localStorage.getItem('currentUser');
        this.currentUserData = JSON.parse(currentUser);
        this.member = new IMember();
        this.company = new ICompany();
        this.branch = new IBranch();
        this.user = AuthService.getLoggedInUser();
        this.role = AuthService.getLoggedInRole();
    }
    closeAddDialog() {
        this.closeDialog.emit();
    }
    saveBodySpecification() {
        const data = {
            ...this.bodySpec,
            memberId: this.memberID
        };
        this.appServiceManager.post("customerVitals/saveBodySpecification", data).subscribe(
            (res) => {
                if (res) {
                    this.closeAddDialog();
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "success",
                        summary: "Success Message",
                        detail: "Body Specification saved successfully."
                    });
                    this.bodySpec = {
                        totalBodyWater: 0,
                        protein: 0,
                        mineral: 0,
                        bodyFatMass: 0,
                        weight: 0,
                        sMM: 0,
                        bMI: 0,
                        pBF: 0,
                        waistHipRatio: 0,
                        visceralFatLevel: 0,
                        height: 0,
                        _id: 0,
                    };
                }
            },
            (error) => {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: "Failed to save Body Specification."
                });
            }
        );
    }
}
